import {Button, Col, Container, Row } from 'react-bootstrap';
import picture from '../assets/img/georgino_picture.png';
import wording from "../assets/json/wording.json";
import cv from '../assets/files/CV_Georginot_Updated_Jan_2023_infographiste.pdf';
function Home() {
    return (
        <section id="home">
            <div className="text-center">
                <img 
                    src={picture}
                    alt="Gino"
                    width="340"
                    className="mt-4 mb-3"/>

                <h3>
                    { wording.home.presentation.name } <br/>
                    { wording.home.presentation.job } 
                </h3>
                <Container>
                    <Row>
                        <Col md={2} lg={3}></Col>
                        <Col lg={6}><p className='text-justify-center'>{ wording.home.presentation.details }</p></Col>
                    </Row>
                    <p className='text-teal font-sans'>{ wording.home.presentation.more }</p>
                    <Button 
                        variant='teal-outline' 
                        className='font-sans'
                        target='_blank'
                        href={cv}>{ wording.button.download_cv }</Button>
                </Container>
            </div>
        </section>
    );
}

export default Home;